// src/BrevoTracker.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BrevoTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const page_name = location.pathname;
    const properties = {}; // optionally include data like query params, title, etc.
    if (window.Brevo && typeof window.Brevo.push === "function") {
      window.Brevo.push(["page", page_name, properties]);
    }
  }, [location]);

  return null; // this component doesn't render anything
};

export default BrevoTracker;